var React = require('react');

function ContentWater (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"content-water"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M17.27,1.37a.91.91,0,0,0-1.46,0C15.2,2.29,1,23.92,1,32.2a15.56,15.56,0,0,0,31.11,0C32.09,23.92,17.87,2.29,17.27,1.37ZM16.54,46A13.82,13.82,0,0,1,2.73,32.2c0-6.74,10.86-24.13,13.81-28.73,2.95,4.6,13.8,22,13.8,28.73A13.81,13.81,0,0,1,16.54,46Z","transform":"translate(-0.48 -0.51)","key":0}),React.createElement("path",{"d":"M13.12,18.7a.87.87,0,0,0-1.18.37C8.56,25.49,6.85,29.9,6.85,32.2a9.69,9.69,0,0,0,3.24,7.22.84.84,0,0,0,.58.22.87.87,0,0,0,.65-.29.88.88,0,0,0-.07-1.24A8,8,0,0,1,8.6,32.2c0-2,1.74-6.33,4.88-12.32A.87.87,0,0,0,13.12,18.7Z","transform":"translate(-0.48 -0.51)","key":1})])]);
}

ContentWater.defaultProps = {"role":"presentation","data-name":"Layer 1","viewBox":"0 0 32.11 47.75"};

module.exports = ContentWater;

ContentWater.default = ContentWater;
